import React from 'react';
import { Ticket, Armchair, Wine, Gift, Check, Utensils, Music, Sparkles } from 'lucide-react';

const ICONS = [
  [/ingress/i, Ticket], [/tavol/i, Armchair], [/consumaz|drink|bevand|bottigl|brindisi|spumant/i, Wine],
  [/panetton|pandoro|dolce|cotechino/i, Gift], [/cena|menu/i, Utensils], [/music|orchestr|ballo/i, Music],
  [/gadget|cotill/i, Sparkles],
];
const iconFor = label => (ICONS.find(([re]) => re.test(label)) || [null, Check])[1];

export function IncludedBox({ items, pkgType }) {
  const list = (items || []).map(s => (s || '').trim()).filter(Boolean);
  if (!list.length) return null;
  return (
    <div className="rounded-2xl p-4 md:p-5 mb-5" data-testid={`capodanno-included-${pkgType}`} style={{
      background: 'linear-gradient(135deg, rgba(251,191,36,0.16), rgba(251,191,36,0.04))',
      border: '1px solid rgba(251,191,36,0.55)',
      boxShadow: '0 0 30px rgba(251,191,36,0.12) inset',
    }}>
      <p className="font-manrope font-800 uppercase tracking-[0.3em] text-[11px] mb-3" style={{ color: '#fbbf24' }}>
        ✦ Cosa è compreso
      </p>
      <ul className="grid grid-cols-2 gap-2.5">
        {list.map((label, i) => {
          const Icon = iconFor(label);
          return (
            <li key={i} className="flex items-center gap-2.5" data-testid={`capodanno-included-item-${pkgType}-${i}`}>
              <span className="w-9 h-9 rounded-xl flex items-center justify-center shrink-0" style={{
                background: 'linear-gradient(135deg, #fbbf24, #b45309)', boxShadow: '0 6px 18px rgba(251,191,36,0.35)',
              }}>
                <Icon size={17} style={{ color: '#1a0a0a' }} />
              </span>
              <span className="font-manrope font-700 text-white text-[13px] sm:text-sm md:text-base leading-tight break-words min-w-0">{label}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
